import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.controller = this;
    this.searchTimeout = null;
    //document.getElementById("loading-gif")?.remove();

    // Initialize with current search value if present
    if ($("#search-results").val() !== "") {
      this.filterSearch();
    }
    
    // Add debounced search for better performance
    $("#search-results").on("keyup", (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filterSearch(e);
      }, 150); // 150ms debounce
    });
    
    // Note: Hollander search is now handled by the hollander-search controller
    // Legacy handler removed as it's replaced by the predictive search dropdown
    
    // Add clear search functionality
    this.addClearSearchButtons();
    
    // Handle browser's native clear X button  
    $("#search-results").on("input", (e) => {
      if (e.target.value === "") {
        this.clearSearch(e.target.id);
      }
    });
  }

  addClearSearchButtons() {
    // Find the search button to position clear button after it
    const searchButton = $("#search-form button[data-action='searches#submit']");
    const form = searchButton.closest('form');
    
    // Add single clear button that handles both inputs
    if (!form.find('.clear-all-search').length) {
      const clearButton = $('<button type="button" class="btn ms-2 clear-all-search" title="Clear all searches" style="background-color: #fff; color: #343a40; border: 1px solid #343a40;"><i class="fas fa-times me-1"></i>Clear</button>');
      clearButton.on('click', () => {
        this.clearAllSearches();
      });
      
      // Add hover effects via JavaScript since inline styles are more reliable than CSS for this
      clearButton.on('mouseenter', function() {
        $(this).css({
          'background-color': '#343a40',
          'color': '#fff',
          'border-color': '#343a40'
        });
      });
      
      clearButton.on('mouseleave', function() {
        $(this).css({
          'background-color': '#fff',
          'color': '#343a40', 
          'border-color': '#343a40'
        });
      });
      
      searchButton.after(clearButton);
    }
    
    // Show/hide clear button based on input values
    this.toggleClearButtons();
  }

  clearSearch(inputId) {
    // Keep this method for browser native clear X functionality
    if (inputId === 'search-results') {
      $("#search-results").val('');
      this.showAllResults();
      $("#search-results").focus();
    }
    // Note: Hollander search clearing is now handled by the hollander-search controller
    this.toggleClearButtons();
  }

  clearAllSearches() {
    const searchValue = $("#search-results").val();
    
    // Check if there's an applied part filter (URL parameter)
    const urlParams = new URLSearchParams(window.location.search);
    const hasAppliedPartFilter = urlParams.has('query') && urlParams.get('query').trim() !== "";
    
    // Clear search results input if it has content
    if (searchValue && searchValue.trim() !== "") {
      $("#search-results").val('');
      this.showAllResults();
    }
    
    // Clear applied part code filter by redirecting (only if actually applied)
    if (hasAppliedPartFilter) {
      // Redirect to clear the part code filter
      window.location.href = this.element.dataset.url;
      return; // Exit early since we're redirecting
    }
    
    // Focus the first input if we're not redirecting
    $("#search-results").focus();
    this.toggleClearButtons();
  }

  toggleClearButtons() {
    // Show/hide single clear button based on either input having content
    const searchValue = $("#search-results").val();
    const clearBtn = $(".clear-all-search");
    
    const hasSearchContent = searchValue && searchValue.trim() !== "";
    
    // For part type filter, only show clear button if filter is actually applied (has URL parameter)
    // Check if current URL has query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const hasAppliedPartFilter = urlParams.has('query') && urlParams.get('query').trim() !== "";
    
    if (hasSearchContent || hasAppliedPartFilter) {
      clearBtn.show();
    } else {
      clearBtn.hide();
    }
  }

  submit(e) {
    // Submit the form - the Hollander search will automatically include the selected Hollander code
    const form = document.getElementById('search-form');
    const formData = new FormData(form);
    const queryParams = new URLSearchParams();
    
    // Add all form data to URL parameters
    for (const [key, value] of formData.entries()) {
      if (value.trim() !== '') {
        queryParams.append(key, value);
      }
    }
    
    // Navigate to the URL with the query parameters
    const baseUrl = this.element.dataset.url;
    const separator = queryParams.toString() ? '?' : '';
    window.location.href = `${baseUrl}${separator}${queryParams.toString()}`;
  }

  toggle() {
    $("#licenseplatedata-modal").modal("hide");
    $("#licenseplatedata-modal").remove();

    $("#turbo_modal").removeAttr("src");
  }

  // Legacy filterAliasSearch method removed - now handled by hollander-search controller

  filterSearch(event = null) {
    if (event !== null && event.key === "Enter") {
      event.preventDefault();
    }
    
    const value = $("#search-results").val().toLowerCase().trim();
    let filteredNodeCount = 0;
    
    // Update clear button visibility
    this.toggleClearButtons();
    
    if (!value) {
      this.showAllResults();
      return;
    }
    
    // Group results by match pairs to maintain alignment
    const matchGroups = this.groupResultsByMatch();
    
    matchGroups.forEach(group => {
      const hasMatch = group.some(element => {
        const text = element.textContent.toLowerCase();
        return text.indexOf(value) > -1 || this.fuzzyMatch(text, value);
      });
      
      group.forEach(element => {
        const $element = $(element);
        if (hasMatch) {
          $element.removeClass('filtered-hidden').show();
          filteredNodeCount++;
        } else {
          $element.addClass('filtered-hidden').hide();
        }
      });
    });
    
    this.updateNoResultsDisplay(filteredNodeCount, value);
    this.reapplyAlternatingRows();
  }

  showAllResults() {
    $("li.header-result").removeClass('filtered-hidden').show();
    this.reapplyAlternatingRows();
    $(".no-result-wrapper").addClass("d-none");
    this.toggleClearButtons();
  }

  updateNoResultsDisplay(count, query) {
    if (count === 0) {
      $("#current-query").text(query);
      $(".no-result-wrapper").removeClass("d-none");
    } else {
      $(".no-result-wrapper").addClass("d-none");
    }
  }

  groupResultsByMatch() {
    const elements = Array.from(document.querySelectorAll("li.header-result"));
    const groups = new Map();
    
    elements.forEach(element => {
      let matchGroup;
      
      // For installed options, each option should be filtered individually
      if (element.dataset.matchGroup && element.dataset.matchGroup.startsWith('installed_option_')) {
        matchGroup = element.dataset.matchGroup + '_' + Array.from(elements).indexOf(element);
      } else {
        // For other features, group by feature ID or match group to show both vehicles' data
        matchGroup = element.dataset.matchGroup || 
                     element.dataset.featureId || 
                     element.textContent.trim().substring(0, 50); // Fallback grouping
      }
      
      if (!groups.has(matchGroup)) {
        groups.set(matchGroup, []);
      }
      groups.get(matchGroup).push(element);
    });
    
    return Array.from(groups.values());
  }

  fuzzyMatch(text, query) {
    // Simple fuzzy matching - check if query words are present
    if (query.length < 3) return false;
    
    const queryWords = query.split(' ').filter(word => word.length > 2);
    return queryWords.some(word => text.includes(word));
  }

  // Reapply alternating row backgrounds to visible rows only
  reapplyAlternatingRows() {
    // Find all visible header-result rows across all sections
    const visibleRows = $("li.header-result:visible");
    
    // Remove existing alternating classes
    visibleRows.removeClass('row-even');
    
    // Apply alternating classes based on visible position
    visibleRows.each((index, element) => {
      if (index % 2 === 0) {
        $(element).addClass('row-even');
      }
    });
  }


}
